import { Button } from "@svea/design-system-components-react";
import { ButtonGroup, Dialog, type LangKey, P, Stack, useText } from "@sveabank/cc-common";
import { APPCONFIG } from "../../utils/config";

type Props = {
	open: boolean;
	setOpen: (isOpen: boolean) => void;
	message: string;
	correlationId?: string;
	heading: LangKey;
	body: LangKey;
};

export const DefaultError = ({ open, setOpen, message, correlationId, heading, body }: Props) => {
	const [t, texts] = useText();

	return (
		<Dialog isOpen={open} setOpen={setOpen} center heading={t(heading)} size="small">
			<Dialog.Content>
				<Stack gap={4}>
					<P>{t(body)}</P>
					{APPCONFIG.MODE === "development" && <code>{message}</code>}
					<P className="text-interactive-disabled">Felkod: {correlationId}</P>
				</Stack>
			</Dialog.Content>
			<ButtonGroup>
				<Button variant="primary" width="full" onPress={() => setOpen(false)}>
					{t(texts.error.modal.close)}
				</Button>
			</ButtonGroup>
		</Dialog>
	);
};
